<template>
    <div class="warpper">
        <div class="flex flex-direction align-center">
            <div class="info-container flex align-center justify-center">
                <img src="../../../../assets/img/icon_time_24.svg"/>
                <span>我们将竭诚为您服务！</span>
            </div>
            <div class="info-container flex flex-direction align-center margin-top-sm">
                <div class="flex align-center">
                    <div class="info-tip">名<span>无</span>称</div>
                    <div class="info-content flex align-center">
                        <div class="content flex-sub">{{orginizInfo.morgname}}</div>
                    </div>
                </div>
                <div class="flex align-center margin-top-xs">
                    <div class="info-tip">电<span>无</span>话</div>
                    <div class="info-content flex align-center">
                        <div class="content flex-sub">{{orginizInfo.morgtel}}</div>
                    </div>
                </div>
                <div class="flex align-center margin-top-xs">
                    <div class="info-tip">联系人</div>
                    <div class="info-content flex align-center">
                        <div class="content flex-sub">{{orginizInfo.contacts}}</div>
                    </div>
                </div>
                <div class="flex align-center margin-top-xs">
                    <div class="info-tip">邮<span>无</span>箱</div>
                    <div class="info-content flex align-center">
                        <div class="content flex-sub">{{orginizInfo.morgemail}}</div>
                    </div>
                </div>
                <div class="flex align-center margin-top-xs">
                    <div class="info-tip">网<span>无</span>址</div>
                    <div class="info-content flex align-center">
                        <div class="content flex-sub">{{orginizInfo.morgurl}}</div>
                    </div>
                </div>
                <div class="flex align-center margin-top-xs">
                    <div class="info-tip">地<span>无</span>址</div>
                    <div class="info-content flex align-center">
                        <div class="content">{{orginizInfo.address}}</div>
                    </div>
                </div>
            </div>
            <div class="info-container flex align-center justify-around margin-top-sm" v-if="orginizInfo.kefu_name">
                <div class="flex align-center justify-center">
                    <img src="../../../../assets/img/icon_service_24.svg"/>
                    <span>您的专属客服：{{orginizInfo.kefu_name}}</span>
                </div>
                <div class="flex align-center justify-center">
                    <img src="../../../../assets/img/icon_phone_24.svg"/>
                    <span>咨询电话：{{orginizInfo.kefu_tel}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getOrganizInfo} from '@/api/member'

    export default {
        name: "contact",
        components: {},
        data() {
            return {
                orginizInfo: '',
            }
        },
        created() {
            this.$emit('setIndex', 1, '联系我们')
            this.init()
        },
        methods: {
            async init() {
                let _data = await getOrganizInfo()
                if (_data.status === 200) {
                    this.orginizInfo = _data.data
                }
            },
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-size: cover;
        background: url(../../../../assets/img/bg_contact.png) no-repeat center;;
        background-size: 100%;
        border-radius: 10px;
        padding: 102px 112px;
        .info-container {
            width: 100%;
            min-height: 129px;
            background-color: #ffffffcc;
            border-radius: 10px;
            font-size: 18px;
            color: #0a2240;
            padding: 55px 0;
            img {
                width: 23px;
                height: 23px;
                margin-right: 12px;
            }
            span{
                line-height: 23px;
            }
            .info-tip {
                width: 62px;
                color: #0a2240;
                font-size: 18px;
                font-weight: bold;
                text-align: justify;
                span {
                    color: transparent;
                }
            }
            .info-content {
                width: 382px;
                height: 39px;
                background-color: #f3f7fb;
                border-radius: 10px;
                padding: 0 20px;
                .content {
                    font-size: 16px;
                    font-weight: bold;
                    color: #0a2240;
                }
            }
        }
    }
</style>